import { StickyHeaderLinksGradBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpStickyHeaderLinksGradBlock } from './AmpStickyHeaderLinksGradBlock';
import { StickyHeaderLinksGradBlock } from './StickyHeaderLinksGradBlock';

export const StickyHeaderLinksGradBlockMapping: BlockMapping<StickyHeaderLinksGradBlockData> =
  {
    invariant: [
      {
        prop: 'links',
        msg: 'Links required for sticky header links',
      },
    ],
    width: 'FULL',
    Component: StickyHeaderLinksGradBlock,
    AmpComponent: AmpStickyHeaderLinksGradBlock,
  };
